<div *ngIf="!isInput">
    <textarea cdkTextareaAutosize matInput appHotkeyComment cdkAutosizeMaxRows="3"
        class="orange-cursor cursor-pointer dots" [readonly]="true" [(ngModel)]="value"
        (click)="openSaveDialog.emit()"></textarea>
</div>
<div class="flex" *ngIf="isInput">
    <input matInput class="orange-cursor cursor-pointer" [matTooltip]="value" [readonly]="true" [(ngModel)]="value"
        (click)="openSaveDialog.emit()">
</div>
